import mira1 from '../../../media/experience/mira/IMG_1427.jpeg';
import mira2 from '../../../media/experience/mira/flight_work.jpeg';
import mira3 from '../../../media/experience/mira/headquarters.MOV';
import miraPoster from '../../../media/experience/mira/MiraIcon.jpeg';

const miraData = {
  company: "MIRA",
  slug: "mira",
  poster: miraPoster,
  location: "San Francisco, CA",
  heroImage: mira1,

  roles: [
    {
      title: "Founding Engineer, Intern",
      start: "May 2025",
      end: "June 2025",
      summary: "After seeing I-XRAY's facial recognition demonstration on social media, I independently built EyeSpy and later developed EyeSpy Meets, a Google Meet integration for real-time facial recognition during video calls, to demonstrate my work to founders AnhPhu Nguyen and Caine Ardayfio. They brought me on as a founding engineering intern, where I led the technical team in scaling the platform from prototype to production. The project received coverage in 404 Media, Wired, [[Forbes::https://www.forbes.com/sites/johnkoetsier/2024/10/03/metas-ray-ban-smart-glasses-used-to-instantly-dox-strangers-in-public-thanks-to-ai-and-facial-recognition/]], and other major outlets. At the San Francisco office, I integrated proprietary recognition algorithms with embedding systems, deployed production infrastructure on AWS EC2, built iOS components, contributed to hardware-software integration for necklace devices, and developed a Chrome extension for video conferencing. I received a full-time offer from the founders but had already committed to my next role at Chipotle.",
    },
  ],

  techStack: [
    "Swift",
    "iOS SDK",
    "AWS EC2",
    "Python",
    "Computer Vision",
    "Facial Recognition",
    "Chrome Extensions",
    "JavaScript",
    "AWS SDK",
    "Hardware Integration",
    "Embedding Systems",
    "REST APIs"
  ],

  gallery: [
    { type: 'image', src: mira1, alt: 'Working at MIRA headquarters' },
    { type: 'image', src: mira2, alt: 'Working on MIRA projects during flight' },
    { type: 'video', src: mira3, alt: 'MIRA Headquarters' }
  ],

  links: {
    company: "https://trymira.com/",
    linkedin: "https://www.linkedin.com/company/mira-glasses/",
  }
};

export default miraData;
